export default __webpack_public_path__ + "assets/images/peergame-light-4c224b1a54d09cccbb050013715fa7af.svg";